'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var project = exports.project = {
    name: 'test',
    dueDate: '2021-01-01',
    location: { city: 'Singapore', country: 'Singapore' },
    product: { image: null },
    thumbnailUrl: ''
};
var price = exports.price = { amount: 100, currency: { symbol: '$' } };
var invoices = exports.invoices = [{
    description: 'test invoice',
    price: price,
    priceWithDiscount: price,
    tax: price,
    total: price,
    uuid: '123'
}];
var creditCards = exports.creditCards = [{
    id: '1',
    last4Digits: '1111',
    createdAt: '2020-01-01',
    owner: {
        uuid: '1',
        name: 'test'
    },
    brand: {
        uuid: '1',
        tradingName: 'test'
    },
    cardBrand: 'test',
    cardFunding: '0',
    expiryMonth: 1,
    expiryYear: 2020,
    permission: 'test',
    updatedAt: '2020-01-01'
}];
//# sourceMappingURL=mocks.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-ui/dist/order/views/pay-page/mocks.js
// module id = 992
// module chunks = 0